import { Instagram, Facebook } from "lucide-react";

const QUICK_LINKS = [
  { label: "Inicio", href: "#hero" },
  { label: "Restaurante", href: "#restaurante" },
  { label: "Menú", href: "#menu" },
  { label: "Hospedaje", href: "#hospedaje" },
  { label: "Reservar", href: "#reservar" },
  { label: "Contacto", href: "#contacto" },
];

const SOCIAL_LINKS = [
  {
    icon: Instagram,
    href: "https://www.instagram.com/restaurante_suchimex?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
    label: "Instagram",
  },
  {
    icon: Facebook,
    href: "https://www.facebook.com/mexicanfoodsuchimex/",
    label: "Facebook",
  },
];

export const Footer = () => {
  return (
    <footer data-testid="main-footer" className="bg-[#1E1C19] py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <h3
              data-testid="footer-brand"
              className="font-heading text-3xl text-[#FAF7F2] tracking-tight mb-4"
            >
              Suchimex
            </h3>
            <p className="text-[#FAF7F2]/50 font-body text-sm leading-relaxed max-w-xs">
              Sabores auténticos y descanso acogedor en el corazón de Suchitoto, El Salvador.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <p className="overline text-[0.65rem] text-[#FAF7F2]/30 mb-6">
              Enlaces
            </p>
            <div className="grid grid-cols-2 gap-3">
              {QUICK_LINKS.map((link, i) => (
                <a
                  key={i}
                  href={link.href}
                  data-testid={`footer-link-${i}`}
                  className="text-[#FAF7F2]/60 font-body text-sm hover:text-[#A25F4B] transition-colors duration-300"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          {/* Social */}
          <div>
            <p className="overline text-[0.65rem] text-[#FAF7F2]/30 mb-6">
              Síguenos
            </p>
            <div className="flex gap-4">
              {SOCIAL_LINKS.map((social, i) => (
                <a
                  key={i}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-social-${social.label.toLowerCase()}`}
                  className="w-10 h-10 border border-[#FAF7F2]/10 flex items-center justify-center text-[#FAF7F2]/50 hover:text-[#A25F4B] hover:border-[#A25F4B]/30 transition-all duration-300"
                >
                  <social.icon size={18} />
                </a>
              ))}
            </div>
            <p className="mt-6 text-[#FAF7F2]/40 font-body text-sm">
              lucilaevaquerano@gmail.com
            </p>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-[#FAF7F2]/5 pt-8 text-center">
          <p className="text-[#FAF7F2]/30 font-body text-xs">
            &copy; {new Date().getFullYear()} Suchimex — Restaurante & Hospedaje. Suchitoto, El Salvador.
          </p>
        </div>
      </div>
    </footer>
  );
};
